import { useState } from "react";
import { Link } from "react-router-dom";

export default function Hero() {
  const [keyword, setKeyword] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    const q = keyword.trim();
    if (q) {
      window.REACT_APP_NAVIGATE(`/works?q=${encodeURIComponent(q)}`);
    }
  };

  return (
    <section className="relative flex min-h-[86vh] items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=stylized%20anime%20landscape%20scene%20of%20a%20vibrant%20comic%20city%20with%20floating%20open%20books%20and%20colorful%20manga%20pages%20drifting%20in%20the%20sky%2C%20warm%20coral%20orange%20and%20gold%20sunset%20palette%20with%20cream%20clouds%20and%20teal%20accents%2C%20youthful%20energetic%20atmosphere%2C%20clean%20artistic%20illustration%20style%2C%20bright%20inviting%20composition%20with%20soft%20light%20rays&width=1600&height=900&seq=hero-dingdong-01&orientation=landscape"
          alt="叮咚漫画网 新作首发与新番上架速递"
          title="叮咚漫画网 新番速递"
          className="h-full w-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/40 to-background-950/70" />
      </div>

      <div className="relative z-10 mx-auto w-full max-w-5xl px-4 py-24 text-center md:px-6">
        <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-4 py-1.5 text-sm font-semibold text-background-50 backdrop-blur">
          <i className="ri-flashlight-fill text-secondary-400" />
          每日更新 · 新番上架速递
        </span>
        <h1 className="mt-6 font-heading text-3xl font-bold leading-tight text-background-50 sm:text-4xl md:text-6xl">
          叮咚漫画网
          <span className="mt-2 block text-2xl text-secondary-300 md:text-4xl">新作首发 · 独家抢先看 · 新番速递</span>
        </h1>
        <p className="mx-auto mt-6 max-w-2xl text-base leading-relaxed text-background-50/90 md:text-lg">
          第一时间上架新作与独家内容，新番抢先看、首发不缺席。每日更新新作列表，热门新漫速递，让你永远快人一步。
        </p>

        <form onSubmit={handleSearch} role="search" className="mx-auto mt-8 flex max-w-xl items-center gap-0 rounded-full border border-background-50/30 bg-background-50/10 p-1.5 backdrop-blur">
          <i className="ri-search-line pl-3 text-lg text-background-50/80" />
          <input
            type="search"
            value={keyword}
            onChange={(e) => setKeyword(e.target.value)}
            placeholder="搜索你喜欢的漫画作品"
            aria-label="搜索漫画作品"
            className="flex-1 bg-transparent px-3 py-2.5 text-sm text-background-50 outline-none placeholder:text-background-50/70"
          />
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-primary-500 px-6 py-2.5 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
          <Link
            to="/new-releases"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-primary-500 px-7 py-3 text-sm font-semibold text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-flashlight-fill" /> 查看新番速递
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-full border border-background-50/40 bg-background-50/10 px-7 py-3 text-sm font-semibold text-background-50 backdrop-blur transition-colors hover:bg-background-50/20"
          >
            <i className="ri-compass-3-line" /> 浏览作品库
          </Link>
        </div>
      </div>
    </section>
  );
}